import ACTION from '../action_constant';
import {combineReducers} from 'redux';

function userProfile(
  state={
    userProfileData : {},
    profileReviews: []
  },
  action
){
  let userProfileData;
  let profileReviews;
  switch (action.type){
    case ACTION.USER_PROFILE.VIEW_PROFILE:
      userProfileData = Object.assign({}, state.userProfileData);
      userProfileData = action.data;
      return Object.assign({}, state, {userProfileData: userProfileData});

    case ACTION.USER_PROFILE.PROFILE_REVIEWS:
      let oldState = Object.assign({}, state);
      if(!action.refreshData){
        profileReviews = oldState.profileReviews;
        let newProfileReviews = [...profileReviews, ...action.data.reviews];
        return Object.assign({}, state, {profileReviews : newProfileReviews});
      }else{
        profileReviews = oldState.profileReviews;
        profileReviews = action.data.reviews;
        return Object.assign({}, state, {profileReviews : profileReviews});
      }


    default:
      return state
  }

}


module.exports = userProfile;



// WEBPACK FOOTER //
// app/user_profile/user_profile_reducer.jsx